// Standard library imports
import React from 'react';
// Internal module imports
import Typography from '../../../components/Typography/Typography';
// External library imports
import _ from 'lodash';
// Css module imports
import classes from '../../../styles/CapacityContent.module.css';
import { getColumnWithSlotSize } from '../../../utils/biddingHelper';

const PriceContent = ({ data }) => {
    const length = _.get(data, ['overall'], []).length || 24;
    const slots = Array.from({ length: length }, (__, i) => i);
    const columns = getColumnWithSlotSize(slots, 8);
    const energyRequestBidStatus = _.get(data, ['energyRequestBidStatus'], []);

    return (
        <div className={`${classes.CapacityContent} ${classes.InfoModalContainer}`}>
            <div>
                <div className={classes.InfoModalHeading}>
                    <Typography content={'Capacity Bid Price'} size={14} />
                </div>
                <div className={classes.Content}>
                    <div className={classes.ContainerStart}>
                        {columns.map((column, colIndex) => (
                            <table key={colIndex}>
                                <thead>
                                    <tr>
                                        <th>Slot</th>
                                        <th>Hour</th>
                                        <th>Cost</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {column.map((key) => (
                                        <tr key={key}>
                                            <td>{key + 1}</td>
                                            <td>
                                                {key}-{key + 1}
                                            </td>
                                            <td>{_.get(data, ['overall', key])}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ))}
                    </div>
                </div>
            </div>

            {_.get(data, 'regulationPrice', []).length ? (
                <div style={{ marginTop: '3vh' }}>
                    {_.get(data, 'energyStatus', '') === 'active' ? (
                        <>
                            <div className={classes.InfoModalHeading}>
                                <Typography content={'Energy Bid Price'} size={14} />
                            </div>

                            <div className={classes.Content}>
                                <div className={classes.ContainerStart}>
                                    {columns.map((column, colIndex) => (
                                        <table key={colIndex}>
                                            <thead>
                                                <tr>
                                                    <th>Slot</th>
                                                    <th>Hour</th>
                                                    <th>Cost</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {column.map((key) => (
                                                    <tr key={key}>
                                                        <td className={_.get(energyRequestBidStatus, [key]) === 'inactive' ? 'orangeColor' : ''}>{key + 1}</td>
                                                        <td className={_.get(energyRequestBidStatus, [key]) === 'inactive' ? 'orangeColor' : ''}>
                                                            {key}-{key + 1}
                                                        </td>
                                                        <td className={_.get(energyRequestBidStatus, [key]) === 'inactive' ? 'orangeColor' : ''}>
                                                            {_.get(data, ['regulationPrice', key])}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    ))}
                                </div>
                            </div>
                        </>
                    ) : (
                        <div className={classes.Title}>The energy bid has not been placed yet. Please check back later</div>
                    )}
                </div>
            ) : (
                ''
            )}
        </div>
    );
};

export default PriceContent;
